module.exports = __webpack_public_path__ + "img/skull_7.8aed79c9.png";